import BaseField, { FieldDefined, FieldTypeDefined, FieldInterface } from '../fieldInterface'

export interface JsonTagDefined extends FieldTypeDefined {
  module: 'jsonTag'
  colors?: Record<string, string>
}

export default class JsonTag extends BaseField<FieldDefined<JsonTagDefined>> implements FieldInterface {
  /**
   * 输出module名称
   * @returns
   */
  static getModuleName () {
    return 'jsonTag'
  }

  /**
   * 获取指定内容对应的颜色
   * @param value
   * @returns
   */
  public getColorsByValue (value:any) {
    const colorMap = this.item.type.colors || {}
    return colorMap[this.getValue(value)] || ''
  }

  /**
   * 输出结果
   * @param h
   * @param value
   * @returns
   */
  public renderField (h:any, value:any) {
    return h('Tag', {
      attrs: {
        color: this.getColorsByValue(this.getValue(value))
      }
    }, this.getValue(value))
  }

  public renderEditField (h:any, value:any, updateValue:Function, placeholder:string) {
    return h('Input', {
      props: {
        value: this.getValue(value),
        placeholder
      },
      on: {
        input: (newValue:any) => {
          const result = this.setTargetValue(value, newValue)
          updateValue(result)
        }
      }
    })
  }
}
